import { render } from "./Layout.vue?vue&type=template&id=349c0dde"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/components/Layout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "349c0dde"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('349c0dde', __exports__)) {
    api.reload('349c0dde', __exports__)
  }
  
  module.hot.accept("./Layout.vue?vue&type=template&id=349c0dde", () => {
    api.rerender('349c0dde', render)
  })

}


export default __exports__